export const CURRENT_LOCATION_MAP_ZOOM = 16;

const isCoordinatePair = (coordinates) => (
  Array.isArray(coordinates)
  && coordinates.length === 2
  && coordinates.every((value) => Number.isFinite(Number(value)))
);

export const getCurrentLocationErrorMessage = (error) => {
  if (error?.kind === 'insecure-context') {
    return 'Геолокация доступна только через защищённое соединение HTTPS';
  }

  if (error?.kind === 'unsupported') {
    return 'Геолокация не поддерживается этим устройством';
  }

  switch (Number(error?.code)) {
    case 1:
      return 'Доступ к геолокации запрещён. Разрешите его в настройках браузера';
    case 2:
      return 'Не удалось определить текущее местоположение';
    case 3:
      return 'Определение местоположения заняло слишком много времени';
    default:
      return 'Не удалось определить текущее местоположение';
  }
};

const createCurrentLocationMarkerElement = () => {
  const markerElement = document.createElement('div');
  markerElement.className = 'map-current-location-marker';
  markerElement.title = 'Моё местоположение';
  markerElement.setAttribute('aria-label', 'Моё местоположение');
  return markerElement;
};

export const replaceCurrentLocationMarker = ({
  map,
  engine,
  previousMarker = null,
  coordinates,
}) => {
  if (!map || !isCoordinatePair(coordinates)) return previousMarker;

  if (previousMarker) {
    try {
      if (engine === 'leaflet') {
        map.removeLayer?.(previousMarker);
      } else if (engine === 'v3') {
        map.removeChild?.(previousMarker);
      } else {
        map.geoObjects?.remove?.(previousMarker);
      }
    } catch {
      // Карта могла быть пересоздана при смене темы или режима отображения.
    }
  }

  const normalizedCoordinates = coordinates.map(Number);

  if (engine === 'leaflet') {
    try {
      const L = window.L || require('leaflet');
      // В normalizedCoordinates: [lng, lat] (как в v3), поэтому для Leaflet: [lat, lng]
      const marker = L.marker([normalizedCoordinates[1], normalizedCoordinates[0]], {
        icon: L.divIcon({
          className: 'map-current-location-leaflet-marker',
          html: createCurrentLocationMarkerElement().outerHTML,
          iconSize: [24, 24],
          iconAnchor: [12, 12]
        }),
        zIndexOffset: 2600
      });
      marker.addTo(map);
      return marker;
    } catch (e) {
      console.warn('Не удалось создать маркер местоположения на Leaflet:', e);
      return null;
    }
  }

  if (engine === 'v3') {
    const Marker = window.ymaps3?.YMapMarker;
    if (!Marker) return null;

    const marker = new Marker({
      coordinates: normalizedCoordinates,
      zIndex: 2600,
    }, createCurrentLocationMarkerElement());
    map.addChild(marker);
    return marker;
  }

  const Placemark = window.ymaps?.Placemark;
  if (!Placemark) return null;

  const marker = new Placemark(
    [normalizedCoordinates[1], normalizedCoordinates[0]],
    { hintContent: 'Моё местоположение' },
    { preset: 'islands#blueCircleDotIcon', zIndex: 2600 },
  );
  map.geoObjects?.add?.(marker);
  return marker;
};
